import React, { FunctionComponent } from 'react'
import * as S from './styled'
import { Direction } from '../../atoms/ArrowIcon/'
import { Label2 } from '../../../theme/typography'
import { DetailedData, EggData } from '../../../redux/requests/products/product.types'
import NameBox from '../../atoms/NameBox'
import config from '../../../configurations'

type OwnProps = {
  details: DetailedData | EggData
  direction: Direction
  moreIsBad: boolean
}

type Props = OwnProps

export const DetailsCard: FunctionComponent<Props> = ({ details, direction, moreIsBad }) => {
  return (
    <S.Card>
      <S.Text>
        <NameBox
          text={config.detailsConfig[details.type].text}
          bgColor={config.detailsConfig[details.type].bgColor}
          type={config.detailsConfig[details.type].name}
        />
        <S.NameLabel>
          <S.DetailValue>{config.detailsConfig[details.type].name}</S.DetailValue>
        </S.NameLabel>
        <S.ValueItem>
          <S.DetailNumber>{(+details?.totalPrice?.toFixed(0)).toLocaleString('fr')}</S.DetailNumber>
          <Label2>Total SEK</Label2>
        </S.ValueItem>

        <S.DetailNumberMobileHidden>
          {details?.amount?.toLocaleString('fr')}
          <Label2>Antal</Label2>
        </S.DetailNumberMobileHidden>

        <S.DetailNumberMobileHidden>
          {(+details?.percentage?.toFixed(1)).toLocaleString('fr')}
          <Label2>Procent</Label2>
        </S.DetailNumberMobileHidden>

        <S.ValueItem>
          <S.DetailNumber>{(+details?.price?.toFixed(2)).toLocaleString('fr')}</S.DetailNumber>
          <Label2>Pris/st</Label2>
        </S.ValueItem>
      </S.Text>
    </S.Card>
  )
}

export default DetailsCard
